import type { LeadInput } from "./lead"

export function leadAction(kind: LeadInput["kind"]) {
  return kind === "project" ? "lead_project" : "lead_contact"
}
